module.exports = __webpack_public_path__ + "static/media/prelevement.99e9eea6.png";